











import { Component, Vue } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import activationGrowlib from './activationGrowlib'
import activationYinhai from './activationYinhai'
import { hostname } from 'os'

@Component({
  components: {
    activationGrowlib,
    activationYinhai
  }
})
export default class Activation extends ViewBase {
  host = ''
  getDomain() {
   this.host = this.$store.state.hostName
  }
  mounted() {
    this.getDomain()
  }
}
